import { ControlListProps, useTranslation, useTranslations } from "@bsm/component";
import _ from "lodash";

export const useUserStudentFamilyMemberForm = (): ControlListProps => {
    const [
        SAVE,
        CANCEL,
        STUDENT,
        TYPE,
    ] = useTranslations(i18n);

    const t = useTranslation()

    return {
        data: {
            forms: [
                {
                    type: "hidden",
                    name: "id",
                },
                {
                    type: 'select',
                    name: 'student',
                    label: STUDENT,
                    required: true,
                    valueObject: true,
                    valueProperty: "id",
                    GQLProps: {
                        gql: `
                            query STUDENT_LIST_GQL {
                                userStudents (filter:{ 
                                    data: { state: "CONFIRMED", isEnrolled: false }
                                    sort: [{ sort: "ASC", value: "studentIdNumber" }] 
                                }) {
                                    data {
                                        id
                                        isEnrolled
                                        user {
                                            id
                                            firstName
                                            lastName
                                            fullName
                                            profilePicture {id}
                                        }
                                    }
                                }
                            }
                        `,
                        rootProp: 'userStudents.data',
                        valueProp: 'id',
                        labelProp: 'user.fullName',
                        userIdProp: "user.id",
                    },
                },
                {
                    type: "checkbox",
                    name: "type",
                    label: TYPE,
                    required: true,
                    options: ['SON', 'DAUGHTER', 'STEPSON', 'STEPDAUGHTER', 'COUSIN', 'UNKNOWN'].map(item => ({
                        label: t(`Bsm.Invoice.User.Student.Family.Members.${item}.Label`),
                        value: item
                    }))
                },
            ],
            graphQL: {
            },
            next: {
                label: SAVE,
                className: "btn btn-primary text-white",
            },
            back: {
                label: CANCEL,
            },
        },
        id: 'user-student-family-create-email-form',
    };
}

const i18n = [
    "std_save",
    "std_cancel",
    "std_students",
    "Bsm.Invoice.User.Student.Family.Members.Type.Label",
];